import React from 'react';
import classnames from 'classnames';
import ReactHtmlParser from 'react-html-parser';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Translate, withLocalize } from 'react-localize-redux';
import { entityIdentRowActions } from '../../store/entityIdentRowStore';
import { layoutActions } from '../../store/layoutStore';
import { lastSubjectActions } from '../../store/lastSubjectsStore';
import { isNullOrUndefined } from '../../store/storeFunctions';
import { popupActions } from '../../store/popupStore';
import { REPORTS, reportActions } from '../../store/reportStore'
import { hasPermission, apiPost, getHostApi, getLanguage, createQs } from '../../store/apiWrapper';
import { AddToPortfolioButton, WarningsButton, AddToClipboardButton, AdvancedInformationButton, PdfExportButton } from '../common/refButtons';

import FoIcon from '../../img/icons/FyzickaOsoba';
import FpoIcon from '../../img/icons/FyzickaOsobaPodnikatel';
import PoIcon from '../../img/icons/PravnickaOsoba';
import AddrIcon from '../../img/icons/Domu';
import { Semaphore } from "../common/semaphors";

import './entityIdentRow.scss';
import { searchActions } from '../../store/searchStore';

class EntityIdentRow extends React.Component {

    constructor(props) {
        super(props);
        this.state = { exportVisible:true, isNameExpanded: false, invokeAdditionalRender: false };
    }

    componentDidMount() { this.pushSubject(); }

    componentDidUpdate(prevProps, prevState) {
        this.pushSubject();
        if (this.state.invokeAdditionalRender) {
            this.setState({ invokeAdditionalRender: false });
        }
        const exportVisible = this.props.reportType !== REPORTS.quick && hasPermission(null, "ReportExport") && this.props.sections;
        if(this.state.exportVisible !== exportVisible) {
            this.setState({exportVisible});
        }
    }

    pushSubject = () => {
        const entityInfo = this.props.entityInfos[this.props.entityId] && this.props.entityInfos[this.props.entityId].result;
        if (isNullOrUndefined(entityInfo))
            return null;

        this.props.pushSubject(entityInfo);
    }

    render() {
        var agentLanguage = "";
        if (!isNullOrUndefined(this.props.user.authentication.profile))
            agentLanguage = this.props.user.authentication.profile.agentLanguage;
        else
            agentLanguage = getLanguage();

        const entityInfo = !isNullOrUndefined(this.props.entityInfos[this.props.entityId]) ? this.props.entityInfos[this.props.entityId].result : null;
        const charts = this.props.location.toLowerCase().indexOf('relation-chart') !== -1;

        if (isNullOrUndefined(entityInfo))
            return null;

        document.title = entityInfo.queryName;

        if(this.props.isMobile === true) {
            return (
                <span className='name' style={{overflow:'hidden', whiteSpace:'nowrap', textOverflow:'ellipsis', margin:'auto'}}>{entityInfo.queryName}</span>
            );
        }

        const className = classnames({ "entity-row": true, "unlimited" : this.props.unlimited, "tinted": this.isTinted() })
        return (
            <React.Fragment>
                <div id='entity-row' className={classnames("entity-row-wrapper", { "tinted": this.isTinted(), 'shadowed': this.props.shadowed, 'is-sticky':this.props.sticky, "unlimited": this.props.unlimited })} style={{ top: this.props.user.authentication.limitedUser? '0px': null, right: this.props.right, fontSize: this.props.isWarning ? '12px': 'inherit' }}>
                    <div ref={el => this.entityRow = el} className={className}>
                        <div className="entity-ident">
                            <div className="name">
                                <div className="left-box">
                                    {entityInfo.type === 1 && ['SK', 'CZ'].includes(entityInfo.country) && <Semaphore type={entityInfo.semaphoreCode ? entityInfo.semaphoreCode : 2} readonly={entityInfo.semaphoreCode ? false : true} size="small" />}
                                    {this.renderIcon(entityInfo)}
                                    <span style={{overflow:'hidden', whiteSpace:'nowrap', textOverflow:'ellipsis'}}>{entityInfo.queryName}</span>
                                    {entityInfo.type < 99 && this.renderEntityData(entityInfo, charts)}
                                </div>
                                {!this.props.unlimited && <div className="right-box">
                                    {charts && <span className="text-nowrap" style={{ marginLeft: '1em' }} id="lblChartNodesCount"><Translate id='Charts.NumberOfNodes' /> {this.props.charts.nodeCount}</span> }
                                    {!charts && this.state.exportVisible && !this.props.isWarning &&
                                        <div className='references print-hidden'>
                                            <div className="ref-buttons" style={{display:'flex'}}>
                                                <PdfExportButton onClick={() => this.props.exportPdf(this.props.entityId)} isEnabled={this.props.isPdfExportEnabled} disabledKey='Common.Button.ExportPdf.Processing' withDelayAfterFirstToggle />
                                            </div>
                                        </div>
                                    }
                                </div>}
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }

    renderEntityData = (entityInfo, charts) => {
        return (
            <React.Fragment>
                {(entityInfo.dateOfBirth || entityInfo.ico) && <span className="separator">|</span> }
                <div className={classnames("ico", {"mobile-hidden": !this.props.unlimited})}>{this.renderAdditionalData(entityInfo, charts)}</div>
            </React.Fragment>
        )
    }

    renderAdditionalData = (entityInfo, charts) => {
        return (
            <React.Fragment>
                {this.renderSubjectId(entityInfo)}
                {/* {charts && <div className="hide-on-desktop" style={{ marginLeft: '0.3rem', marginRight: '0.3rem' }}>|</div>} */}
                <div className='references print-hidden'>
                    <div className="ref-buttons" style={{display:'flex'}}>
                        {!this.props.user.authentication.limitedUser && this.renderButtons(entityInfo)}
                    </div>
                </div>
            </React.Fragment>
        )
    }

    onResize = _ => {
        // set height of entity row otherwise scrollspy and scrolling wont work.
        // Do it only in mobile mode because in desktop mode the page header is set in top panel component.
        window.innerWidth <= 992 && this.props.setPageHeaderHeight(this.entityRow.clientHeight);
        this.setState({ invokeAdditionalRender: true });
    }

    renderSubjectId = (s) => {
        return <div className="ico-inner">
            {s.type === 2 ? <>
                    {s.dateOfBirth && <>
                        <span><Translate id="Report.NaturalIdentData.DateOfBirth" />:&nbsp;</span>
                        <span className={s.entrepreneur ? "qs-result-id-entrepreneur" : null}>{s.dateOfBirthFormated}</span>
                </>}
            </> : <>
                    {s.ico && <>
                        <span><Translate id="Report.CompanyIdentification.Ico" />:&nbsp;</span>
                        <span className={s.entrepreneur ? "qs-result-id-entrepreneur" : null}>{ReactHtmlParser(s.ico)}</span>
                    </>}
                </>}
        </div>
    }

    renderButtons = (info) => {
        return (
            <React.Fragment>
                {((info.reports || {}).NI && !this.props.isWarning)&& <WarningsButton link={`/warnings/${this.props.entityId}`} />}
                <AddToPortfolioButton onClick={() => this.openPortfolioPopup(info)} />                
                <AddToClipboardButton entityId={info.entityId} onAdd={() => this.props.addToClipboard(info, this.props.translate('Search.Clipboard.SubjectAdded'))}
                    onRemove={() => this.props.removeFromClipboard(info, this.props.translate('Search.Clipboard.SubjectRemoved'))} />
                    <AdvancedInformationButton entityInfo={info} id={"AdvancedInformationButton"}/>
            </React.Fragment>
        )
    }

    renderIcon = entityInfo => {
        const Icon = entityInfo.type === 1 ? (entityInfo.entrepreneur === true ? FpoIcon : PoIcon) : (entityInfo.type < 99 ? FoIcon : AddrIcon);
        return <div className="entity-icon" style={{margin:'0 0.25em'}}><Icon className='icon-align-to-text svg-standard-fill' /></div>;
    }

    componentDidMount() {
        this.props.ensureEntityInfo(this.props.entityId);
    }

    componentWillUnmount() {
        document.title = "Cribis";
    }

    isTinted = () => {
        try {
            return localStorage.locales_tint === 'header';
        } catch {
            return false;
        }
    }

    openPortfolioPopup = (subject) => {
        this.props.showPopup("addToPortfolioPopup", {
            open: true,
            subject,
            ok: () => { },
            close: () => { this.props.hidePopup(); }
        })
    }
}

export default withLocalize(connect(
    state => ({ ...state.entityIdentRow, ...state.report , ...state.layout, user: state.userContext, charts: state.charts }),
    dispatch => bindActionCreators({ ...entityIdentRowActions, ...layoutActions, ...lastSubjectActions, ...popupActions, ...searchActions, ...reportActions }, dispatch)
)(EntityIdentRow));
